/**
 * Deep H: the clock is short and the cave is rich. Eight clocks, each worth ten seconds, lie in
 * awkward places: a creeper vein, a firefly's orbit, under a boulder column, behind a door
 * (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepH: CaveDef = {
  id: 'H',
  name: 'BORROWED TIME',
  hint: 'You start short of time. Every clock buys ten seconds.',
  intermission: false,
  colors: [4, 14, 7],
  diamondValue: 20,
  extraValue: 35,
  fill: { base: '.', items: [['r', 11], ['d', 7]] },
  levels: [
    { seed: 5801, diamonds: 18, time: 60 },
    { seed: 5802, diamonds: 20, time: 55 },
    { seed: 5803, diamonds: 22, time: 50 },
    { seed: 5804, diamonds: 24, time: 45 },
    { seed: 5805, diamonds: 26, time: 40 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W....????????????????????wwwww?????????W',
    'W.P..t.t?????????????????w f w?????????W',
    'W........??????????????... t w?????????W',
    'W?.??????????????????????w   w?????????W',
    'Ww.wwwwwwwwwwwwwww???????wwwww?????????W',
    'Wx.d.t..d.d.dt.d.w?????????????????????W',
    'Wwwwwwwwwwwwwwww.w?????????????????????W',
    'W??????????????...?????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????.1.???????????wrw???W',
    'W????????????????????????????????wrw???W',
    'W????????????????????????????????wrw???W',
    'W????????????????????????????????wrw???W',
    'W????????????????????????????????wrw???W',
    'W????????????????????????????????wrw???W',
    'W?wwwww?????????????????????????..t.???W',
    'W?w.t.4.????????????????????????.www???W',
    'W?wwwww????????????????????????????????W',
    'W?????????????????????????????t???.....W',
    'W?????????????????????????????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
